import { createFileRoute } from "@tanstack/react-router";
import {
  SubscriptionFailedPage,
  SubscriptionPendingPage,
} from "@/pages/subscription-setup";
import { parseFailedSearch } from "@/pages/subscription-setup/lib/failed-search";

const FailedRoute = () => {
  const { reason } = Route.useSearch();
  const { companySlug } = Route.useParams();

  return reason === "timeout" ? (
    <SubscriptionPendingPage companySlug={companySlug} />
  ) : (
    <SubscriptionFailedPage />
  );
};

export const Route = createFileRoute(
  "/_authed/_noSidebar/$companySlug/subscribe/failed",
)({
  validateSearch: parseFailedSearch,
  component: FailedRoute,
});
